import { render, staticRenderFns } from "./HealthStationHomePage.vue?vue&type=template&id=4c89d2ba&scoped=true"
import script from "./HealthStationHomePage.vue?vue&type=script&lang=js"
export * from "./HealthStationHomePage.vue?vue&type=script&lang=js"
import style0 from "./HealthStationHomePage.vue?vue&type=style&index=0&id=4c89d2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c89d2ba",
  null
  
)

export default component.exports